import React, { useState } from "react";
import { Button, Col, Container, Row, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import authApi from "../api/authApi";
import SparkApi from "../api/SparkApi";
import { toast, ToastContainer } from "react-toastify";

const ChangePassword = ({ userId }) => {
    const paramId = useParams();
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);
    const [user, setUser] = useState({password: '', confirmpassword: ''});
    const [passwordError, setPasswordError] = useState("");
    const [checkPassword, setCheckPassword] = useState(true);
    // const handleChange = (e) => {
    //     setUser({ ...user, [e.target.name]: e.target.value });
    // };

    const handleChange = (e) => {
        const trimmedValue = e.target.value.replace(/\s/g, "");
        const passwordRegex =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        const isValidPassword = passwordRegex.test(trimmedValue);
        setUser({
          ...user,
          [e.target.name]: trimmedValue,
        });
        if (!isValidPassword) {
          setPasswordError("Password must be 8+ chars with A-Z, a-z, 0-9 & special char.");
        } else {
          setPasswordError(""); // Clear error if valid
        }
        setCheckPassword(true);
      };

    const handleSubmit = async(e) => {
        e.preventDefault();

        if(user.password && user.confirmpassword){
            if( user.password !== user.confirmpassword){
                return
            }
        }
            

        if (Object.keys(passwordError).length > 0) {
            return toast.error("invalid password");
          }

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }
        setValidated(true);
        if (user.password === user.confirmpassword && user.password !== '') {
            const result = await SparkApi.updateUser(user, paramId?.id);
            toast.success("Password updated successfully");
            setTimeout(()=> {
                authApi.logout();
                navigate("/login");
            } , 2000);
        } else {
            ////console.log('Password is null, please enter a valid password.');
        }
    };

    console.log('user-->',user);

    return (
        <div>
            <Container className="view-form">
                <Row>
                    <Col></Col>
                    <Col lg={8}>
                        <Form className="mt-3" onSubmit={handleSubmit} validated={validated}>
                            <Row className="view-form-header align-items-center ">
                                <Col lg={3}>
                                    Change Password
                                </Col>
                                <Col lg={9} className="d-flex justify-content-end">
                                    <Button className="btn-sm mx-2" onClick={handleSubmit}>
                                        Update
                                    </Button>
                                </Col>
                            </Row>
                            <Row className="ibs-edit-form pb-3">
                                <Col lg={12}>
                                    <Form.Group className="mx-3" controlId="formBasicFirstName">
                                        <Form.Label
                                            className="form-view-label"
                                            htmlFor="formBasicFirstName"
                                        >
                                          New Password
                                        </Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="password"
                                            placeholder="Enter Your password"
                                            onChange={handleChange}
                                            required
                                        />
                                          {passwordError ? (
                              <span
                                style={{
                                  // color: "#DC3545",
                                  // fontWeight: "600",
                                  // paddingTop: "5px",
                                  // fontSize: "6.90px",
                                  color: "#f62b2b",
                                  fontWeight: "600",
                                  paddingTop: "5px",
                                }}
                              >
                                {/* <i class="fa-regular fa-circle-check pt-1 px-1"></i> */}
                                {passwordError}
                              </span>
                            ) : (
                              ""
                            )}
                                    </Form.Group>
                                </Col>
                                <Col lg={12}>
                                    <Form.Group className="mx-3" controlId="formBasicPhone">
                                        <Form.Label
                                            className="form-view-label"
                                            htmlFor="formBasicPhone"
                                        >
                                            Confirm Password
                                        </Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="confirmpassword"
                                            placeholder="Enter confirm password"
                                            onChange={handleChange}
                                            required
                                        />
                                                <b
  className="mt-3"
  style={{
    color: user.password === user.confirmpassword ? "#2bd965" : "#f62b2b",
    fontWeight: "600",
  }}
>
  {!passwordError && user.password && user.confirmpassword
    ? user.password === user.confirmpassword
      ? "Passwords match"
      : "Passwords do not match"
    : ""}
</b>
                                    </Form.Group>
                                </Col>
                            </Row>
                           
                        </Form>
                    </Col>
                    <Col></Col>
                </Row>
            </Container>
            <ToastContainer theme="light" autoClose={2000} pauseOnHover position="top-center" />
        </div>
    );
};

export default ChangePassword;